
  var _styles = {
  "guest-assist-modal__vap-wrapper": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "10rem",
    "zIndex": 0
  },
  "guest-assist-modal__content-layer": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "position": "relative",
    "zIndex": 2
  },
  "guest-assist-modal__header-img": {
    "width": "8rem",
    "height": "1.28rem"
  },
  "guest-assist-modal__content-wrapper": {
    "marginTop": "0.26667rem",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "center",
    "backgroundColor": "rgb(255,255,255)",
    "borderRadius": "0.64rem",
    "width": "8rem",
    "height": "9.49333rem"
  },
  "guest-assist-modal__icon": {
    "marginTop": "0.33333rem",
    "width": "6.09333rem",
    "height": "4.68rem"
  },
  "guest-assist-modal__title": {
    "marginTop": "0.33333rem",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.48rem",
    "textAlign": "center"
  },
  "guest-assist-modal__desc": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.48rem"
  },
  "guest-assist-modal__button": {
    "position": "absolute",
    "zIndex": 1,
    "width": "5.33333rem",
    "height": "1.28rem",
    "borderRadius": "0.8rem",
    "bottom": "0.64rem",
    "backgroundColor": "rgb(255,221,0)",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "guest-assist-modal__button-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.48rem",
    "textAlign": "center"
  },
  "modal-close-button": {
    "marginTop": "0.56rem",
    "height": "0.64rem",
    "width": "100%",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "position": "relative",
    "zIndex": 2
  },
  "modal-close-button-img": {
    "width": "0.64rem",
    "height": "0.64rem"
  }
};



  module.exports = _styles;
  